export default __webpack_public_path__ + "static/media/appleColoringSample.26dbcb677faf8e98d9580f8c13d77a3b.png";